import script from "./VendorCodeCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./VendorCodeCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./VendorCodeCellElementLite.vue?vue&type=style&index=0&id=c1fc6934&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1fc6934"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QMenu,QCard,QDialog});
